import { ReactElement } from "react"

import CreateV2GBundleForm from "../../../../components/devices/lct/v2gBundle/createV2GBundleForm"
import PublishV2GBundleProvider from "../../../../components/devices/lct/v2gBundle/providers/publishV2GBundleProvider"

const PublishV2GBundleDevice = (): ReactElement => (
    <PublishV2GBundleProvider>
        <CreateV2GBundleForm />
    </PublishV2GBundleProvider>
)

export default PublishV2GBundleDevice
